import { render } from "./TaskModalCreate.vue?vue&type=template&id=78bb740a"
import script from "./TaskModalCreate.vue?vue&type=script&lang=js"
export * from "./TaskModalCreate.vue?vue&type=script&lang=js"

import "./TaskModalCreate.vue?vue&type=style&index=0&id=78bb740a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__